<div class="web-view" fxHide.xs fxHide.sm fxHide.lt-md fxFlex.md>
  <div class="navbar-div">
    <app-web-navbar></app-web-navbar>
  </div>

  <div class="main-div" fxLayout="row wrap">
    <div fxLayout="row">
      <div fxLayout="column wrap" class="description-div">
        <h1 class="heading">Cinejoy Artist & Audience Meetups</h1>
        <p>
          Join or Host an exciting Cinejoy Meetup! Meetups are fun and welcoming
          gatherings of new and old friends to discuss/share your thoughts and
          feelings about a Cinejoy Movie or Event.
          <br /><br />
          Hosts can choose their Cinejoy Showcase Film or Spotlight Event for
          discussion and the time/date for the party. Both artists and audiences
          are encouraged to Host Meetups.
          <br /><br />
          Meetup participants can choose amongst the schedule of Meetups.
          Attendance is free, yet you must agree to watch the associated
          Showcase Movie or Spotlight Event prior to the party. All are welcome
          until the space of the Meetup is filled. During the meetup you can
          choose to just watch and listen or to participate in the conversations
          and sharing.
          <br /><br />
        </p>
      </div>

      <div class="image-div" fxLayout="column wrap">
        <img
          class="image"
          src="assets/images/cinejoy/Hero-popcorn.png"
          alt="Cinejoy Home Page"
        />
      </div>
    </div>
    <div fxLayout="row wrap" class="button-main-div">
      <div
        fxLayout="row wrap"
        class="button-div"
        fxLayoutAlign="start center"
        fxLayoutGap="50px"
      >
        <button class="btn" (click)="gotoJoin()">
          <span class="btn_effect">Join an Artist & Audience Meetup</span>
        </button>
        <button class="btn" (click)="gotoHost()">
          <span class="btn_effect">Host an Artist & Audience Meetup</span>
        </button>
      </div>
    </div>
  </div>

  <div class="footer-div">
    <app-cinejoy-footer></app-cinejoy-footer>
  </div>
</div>
<!-- wev view ended -->

<!-- mobile view started -->

<div
  class="mobile-view"
  fxHide.lg
  fxHide.md
  fxHide.lt
  fxFlex.lt-md
  fxShow.xs
  fxHide.gt-lg
>
  <div class="mobile-navbar">
    <app-sidebar></app-sidebar>
  </div>

  <div class="navbar-div">
    <app-web-navbar></app-web-navbar>
  </div>

  <div class="main-div-mob" fxLayout="column wrap">
    <div fxLayout="column">
      <div class="image-div-mob" fxLayout="column" fxLayoutAlign="start center">
        <img
          class="image-mob"
          src="assets/images/cinejoy/Hero-popcorn.png"
          alt="Cinejoy Home Page"
        />
      </div>

      <div fxLayout="column" class="description-div-mob">
        <h1 class="heading-mob">Artist & Audience Meetup</h1>

        <p class="description">
          Join or Host an exciting Cinejoy Meetup! Meetups are fun and welcoming
          gatherings of new and old friends to discuss/share your thoughts and
          feelings about a Cinejoy Movie or Event.
          <br /><br />
          Hosts can choose their Cinejoy Showcase Film or Spotlight Event for
          discussion and the time/date for the party. Both artists and audiences
          are encouraged to Host Meetups.
          <br /><br />
          Meetup participants can choose amongst the schedule of Meetups.
          Attendance is free, yet you must agree to watch the associated
          Showcase Movie or Spotlight Event prior to the party. All are welcome
          until the space of the Meetup is filled. During the meetup you can
          choose to just watch and listen or to participate in the conversations
          and sharing.
        </p>
      </div>

      <div fxLayout="column wrap" class="button-div-mob" fxLayoutGap="10px">
        <button class="mobileBtn" (click)="gotoJoin()">
          Join an Artist & Audience Meetup
        </button>
        <button class="mobileBtn" (click)="gotoHost()">
          Host an Artist & Audience Meetup
        </button>
      </div>
    </div>
  </div>

  <div class="footer-div">
    <app-cinejoy-mobile-footer></app-cinejoy-mobile-footer>
  </div>
</div>
